(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  console.log('[search-debug] script loaded');

  function isIOS() {
    var ua = window.navigator.userAgent || '';
    var platform = window.navigator.platform || '';
    var ios =
      /iPad|iPhone|iPod/.test(ua) ||
      (platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    console.log('[search-debug] isIOS():', ios, 'ua:', ua, 'platform:', platform);
    return ios;
  }

  function getVisibleSearchInput() {
    var candidates = document.querySelectorAll(
      '.search__input, input[type="search"], input[name="q"], .js-search-input'
    );
    console.log('[search-debug] candidates found:', candidates.length);

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      console.log(
        '[search-debug] checking candidate',
        i,
        'class=',
        el.className,
        'offsetParent=',
        el.offsetParent
      );
      if (el.offsetParent !== null) {
        console.log('[search-debug] using candidate index', i);
        return el;
      }
    }

    console.warn('[search-debug] no visible search input found');
    return null;
  }

  function focusSearchInput(source) {
    console.log('[search-debug] focusSearchInput called from:', source);

    var input = getVisibleSearchInput();
    if (!input) {
      console.warn('[search-debug] focusSearchInput: no input to focus');
      return;
    }

    console.log('[search-debug] focusing input:', input);
    input.focus();

    try {
      var len = input.value.length;
      input.setSelectionRange(len, len);
      console.log('[search-debug] setSelectionRange success, len =', len);
    } catch (e) {
      console.warn('[search-debug] setSelectionRange error:', e);
    }
  }

  // CLICK HANDLER (capture = true so nothing can swallow it before us)
  document.addEventListener(
    'click',
    function (e) {
      console.log('[search-debug] document click, target:', e.target);

      var trigger = e.target.closest('.search__trigger');
      console.log('[search-debug] trigger found?', !!trigger);

      if (!trigger) return;

      console.log(
        '[search-debug] click on .search__trigger, href=',
        trigger.getAttribute('href')
      );

      // Prevent jump for href="#"
      if (trigger.matches('a[href="#"], a[href=""]')) {
        e.preventDefault();
        console.log('[search-debug] prevented default for "#" link');
      }

      if (isIOS()) {
        console.log('[search-debug] iOS branch in click');
        // small delay to allow any overlay to open
        setTimeout(function () {
          focusSearchInput('iOS click timeout');
        }, 80);
      } else {
        console.log('[search-debug] non-iOS branch in click');
        setTimeout(function () {
          focusSearchInput('non-iOS click timeout');
        }, 0);
      }
    },
    true // <-- capture phase
  );

  // Extra safety for iOS touch
  document.addEventListener(
    'touchend',
    function (e) {
      if (!isIOS()) return;
      console.log('[search-debug] touchend event, target:', e.target);

      var trigger = e.target.closest('.search__trigger');
      console.log('[search-debug] touchend trigger found?', !!trigger);
      if (!trigger) return;

      focusSearchInput('iOS touchend');
    },
    { passive: true, capture: true }
  );
})();

  } catch(e) { console.error(e); }
})();
})();
